import InspectionStatisticTable from './InspectionStatisticTable';

export default InspectionStatisticTable;
